
import ChevronIcon from '~/assets/icons/chevron.svg'

export default {
  name: 'Breadcrumbs',
  components: {
    ChevronIcon
  },
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
}
